// This is the old checkbox please us th
// import '@banno/jha-wc/src/forms/jha-form-checkbox/jha-form-checkbox';
import { InputCheckedEvent } from '@banno/jha-wc/src/js/utils/types';
import '@jack-henry/jh-ui/components/checkbox/checkbox.js';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmFormControl } from '../forms';

const tagName = 'tm-wc-checkbox';

@customElement(tagName)
export class TmCheckbox extends TmFormControl<boolean> {
    @property({ type: String })
    public label?: string;

    @property({ type: String })
    public helperText?: string;

    @property({ type: Boolean, reflect: true })
    public disabled?: boolean;

    @property({ type: Boolean })
    public indeterminate?: boolean;

    protected validate() {
        return true;
    }

    protected render() {
        return html`<jh-checkbox
            @jh-change=${this.handleChange}
            ?checked=${this.value ?? false}
            ?disabled=${this.disabled}
            ?indeterminate=${this.indeterminate}
            .label=${this.label ?? ''}
            .helperText=${this.helperText ?? ''}
        >
        </jh-checkbox>`;
    }

    private handleChange(e: InputCheckedEvent) {
        const { checked } = e.target as HTMLInputElement;
        this.changeValue(checked);
    }

    public static get styles() {
        return css`
            :host {
                display: flex;
            }
            jh-checkbox {
                /* Colors by checkbox state. See https://www.figma.com/design/L8h2Fumxvo6xxf1TUkU5uy/Platform-web?node-id=61-30338&m=dev  */
                --checked: #085ce5;
                --disabled: ##83adf2;
                --unchecked: #707070;

                /* Checkbox border colors for various states */
                --jh-checkbox-input-color-border-indeterminate-active: var(--unchecked);
                --jh-checkbox-input-color-border-indeterminate-disabled: var(--disabled);
                --jh-checkbox-input-color-border-indeterminate-enabled: var(--unchecked);
                --jh-checkbox-input-color-border-indeterminate-focus: var(--unchecked);
                --jh-checkbox-input-color-border-indeterminate-hover: var(--unchecked);
                --jh-checkbox-input-color-border-selected-active: var(--checked);
                --jh-checkbox-input-color-border-selected-disabled: var(--disabled);
                --jh-checkbox-input-color-border-selected-enabled: var(--checked);
                --jh-checkbox-input-color-border-selected-focus: var(--checked);
                --jh-checkbox-input-color-border-selected-hover: var(--checked);
                --jh-checkbox-input-color-border-unselected-active: var(--unchecked);
                --jh-checkbox-input-color-border-unselected-disabled: var(--disabled);
                --jh-checkbox-input-color-border-unselected-enabled: var(--unchecked);
                --jh-checkbox-input-color-border-unselected-focus: var(--unchecked);
                --jh-checkbox-input-color-border-unselected-hover: var(--unchecked);

                /* Checkbox background colors for various states */
                --jh-checkbox-input-color-background-indeterminate-active: transparent;
                --jh-checkbox-input-color-background-indeterminate-disabled: var(--disabled);
                --jh-checkbox-input-color-background-indeterminate-enabled: transparent;
                --jh-checkbox-input-color-background-indeterminate-focus: transparent;
                --jh-checkbox-input-color-background-indeterminate-hover: transparent;
                --jh-checkbox-input-color-background-selected-active: var(--checked);
                --jh-checkbox-input-color-background-selected-disabled: var(--disabled);
                --jh-checkbox-input-color-background-selected-enabled: var(--checked);
                --jh-checkbox-input-color-background-selected-focus: var(--checked);
                --jh-checkbox-input-color-background-selected-hover: var(--checked);
                --jh-checkbox-input-color-background-unselected-active: transparent;
                --jh-checkbox-input-color-background-unselected-disabled: var(--disabled);
                --jh-checkbox-input-color-background-unselected-enabled: transparent;
                --jh-checkbox-input-color-background-unselected-focus: transparent;
                --jh-checkbox-input-color-background-unselected-hover: transparent;
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmCheckbox;
    }
}
